
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link, Stack, Checkbox, TextField, IconButton,Button, InputAdornment, FormControlLabel, Container } from '@mui/material';
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { baseURL } from '../base_url';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Modal } from 'react-bootstrap';
import { styled } from '@mui/material/styles';
import img from '../../assets/img/6022193.jpg';
import img2 from '../../assets/img/9684913.jpg';
import { PuffLoader } from 'react-spinners';
import logo from '../../assets/img/RezGlobal.png'
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// import Iconify from './Iconify';
import './Login.css'
// ----------------------------------------------------------------------
const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  }));

export default function LoginForm({ setLoginSuccess }) {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [Email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberPassword, setRememberPassword] = useState(false);
  const [forgotPasswordClicked, setForgotPasswordClicked] = useState(false);
  const [loginDetail, setLoginDetail] = useState("");
  const [otpExpireTime, setOtpExpireTime] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [userCaptchaInput, setUserCaptchaInput] = useState('');
  // const [captchaError, setCaptchaError] = useState('');
  // const [captchaValidated, setCaptchaValidated] = useState(false);
  // const [captchaText, setCaptchaText] = useState('');
  // const [captchaStyles, setCaptchaStyles] = useState([]);



  // Function to generate a new CAPTCHA string
  // const generateCaptcha = () => {
  //   const characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789!@#$%^&*()';
  //   let result = '';
  //   for (let i = 0; i < 6; i++) {
  //     result += characters.charAt(Math.floor(Math.random() * characters.length));
  //   }
  //   setCaptchaText(result);
  //   setUserCaptchaInput('');
  // };

//   const generateCaptcha = () => {
//   const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//   let result = '';
//   let styles = [];
//   for (let i = 0; i < 6; i++) {
//     const char = chars.charAt(Math.floor(Math.random() * chars.length));
//     result += char;

//     styles.push({
//       fontSize: `${Math.floor(Math.random() * 4 + 18)}px`,
//       textShadow: `${Math.random() * 2}px ${Math.random() * 2}px rgba(0,0,0,0.2)`,
//     });
//   }
//   setCaptchaText(result);
//   setCaptchaStyles(styles);
// };


  // useEffect(() => {
  // generateCaptcha();
  // }, []);

    // Validate user's input with the generated CAPTCHA
  //   const isCaptchaValid = () => {
  //   if (userCaptchaInput.trim().toUpperCase() === captchaText.toUpperCase()) {
  //     setCaptchaError('');
  //     return true;
  //   } else {
  //     setCaptchaError('Captcha does not match. Try again.');
  //     generateCaptcha();
  //     return false;
  //   }
  // };

  const MyModal = ({ showModal, handleClose }) => {
    const [otpValue, setOtpValue] = useState("");
    let otpAttempts = 0;
    let isOtpBlocked = false;
    let blockOtpUntil = null;
    const handleSubmitOtp = (e) => {
      e.preventDefault();


      if (isOtpBlocked && new Date().valueOf() < blockOtpUntil) {
        const remainingSeconds = Math.floor((blockOtpUntil - new Date().valueOf()) / 1000);
        Swal.fire({
          icon: 'error',
          title: 'Too Many Attempts',
          text: `You are blocked from entering OTP. Please wait ${remainingSeconds} seconds.`,
        });
        return;
      }
      


      if (otpValue.toString().trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Please enter Authentication Key'
        })
        return;
      }
      if ((otpExpireTime + (1000 * 60)) < (new Date()).valueOf()) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Authentication key expired'
        })
        setLoading(false);
        return;
      }
      setLoading(true);
      axios.post(baseURL + "/check_authentication_key",
      { 'authentication_key': otpValue, 'email': Email.toString().trim().toLowerCase() })
      .then((res) => {
        if (res.data.status === 'Matched') {
          otpAttempts = 0;
          sessionStorage.setItem('tm_token', JSON.stringify({
            'tm_name': loginDetail.data.data.user_name, 
            'tm_email': loginDetail.data.data.user_email, 
            'tm_role': loginDetail.data.role, 
            'tm_id':loginDetail.data.data.id, 
            'tm_accessRole':loginDetail.data.accessRole,
            'auth_token': res.data.token
          }))
          handleClose();
          navigate('/');
          window.location.reload();
        }else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Authentication key not matched'
          })
          if (otpAttempts >= 3) {
            isOtpBlocked = true;
            blockOtpUntil = new Date().valueOf() + 60 * 1000; // block for 1 minute
            Swal.fire({
              icon: 'error',
              title: 'Too Many Attempts',
              text: 'You are blocked from entering OTP for 1 minute.'
            });
            // handleClose();
          }
          setLoading(false);
          handleClose();
          setForgotPasswordClicked(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleClose();
        if (error.response && error.response.status === 429) {
          const waitSeconds = error.response.data?.wait_seconds || 60;
          let totalSeconds = waitSeconds;

          Swal.fire({
            title: "Too Many OTP Attempts 🔐",
            html: `
              <p>Please wait <strong id="otp-timer">${Math.floor(totalSeconds / 60)}:${(totalSeconds % 60).toString().padStart(2, "0")}</strong> before trying again.</p>
            `,
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              const timerElement = Swal.getHtmlContainer().querySelector("#otp-timer");
              const timer = setInterval(() => {
                totalSeconds -= 1;
                if (totalSeconds <= 0) {
                  clearInterval(timer);
                  Swal.close();
                } else {
                  const minutesLeft = Math.floor(totalSeconds / 60);
                  const secondsLeft = totalSeconds % 60;
                  timerElement.textContent = `${minutesLeft}:${secondsLeft.toString().padStart(2, "0")}`;
                }
              }, 1000);
            }
          });

          
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong during OTP verification.'
          });
        }
      });
      return;
    }

    return (
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Authentication Key</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Stack spacing={10}>
                <TextField
                autoComplete="OTP"
                type="text"
                label="OTP"
                value={otpValue}
                onChange={(e) => setOtpValue(e.target.value)}
                />
            </Stack>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" onClick={handleSubmitOtp}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const handleSubmit = (e) => {
    e.preventDefault();
    // handleShow();
    // return;

    // if (!isCaptchaValid()) {
    //     return;
    //   }

    if (Email.toString().trim() === '') {
      Swal.fire("Please enter Email")
      return;
    }
    if (!emailRegex.test(Email)){
      Swal.fire("Please enter valid Email")
      return;
    }
    if (password.toString().trim() === '') {
      Swal.fire("Please enter Password")
      return;
    }
    setLoading(true);
    axios.post(baseURL + "/validate_credential", {
      'Email': Email.toString().trim().toLowerCase(),
      'password': password
    }, {
      withCredentials: true
    })
      .then((res) => {
        if (res.data.status === 'success'){
          axios.post(baseURL + "/mail_authentication_check", {
            'user_email': Email.toString().trim().toLowerCase(),
            'role': res.data.role
          }).then((res5) => {
            setLoading(false);
            setOtpExpireTime((new Date()).valueOf());
            setLoginDetail(res);
            handleShow();
          })
          .catch(() => {
              Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Error generating OTP. Please try again.'
              })
            })
          } else if(res.data.status == 'locked'){
              const minutesMatch = res.data.message.match(/(\d+)\s+minutes/);
              let totalSeconds = minutesMatch ? parseInt(minutesMatch[1], 10) * 60 : 0;

              Swal.fire({
                title: "Account Locked 🔒",
                html: `
                  <p>Please wait <strong id="timer">${Math.floor(totalSeconds / 60)}:${(totalSeconds % 60).toString().padStart(2, "0")}</strong> before trying again.</p>
                `,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                  const timerElement = Swal.getHtmlContainer().querySelector("#timer");
                  const timer = setInterval(() => {
                    totalSeconds -= 1;
                    if (totalSeconds <= 0) {
                      clearInterval(timer);
                      Swal.close();
                    } else {
                      const minutesLeft = Math.floor(totalSeconds / 60);
                      const secondsLeft = totalSeconds % 60;
                      timerElement.textContent = `${minutesLeft}:${secondsLeft.toString().padStart(2, "0")}`;
                    }
                  }, 1000); // tick every second
                }
              })
              setLoading(false)
        }else if (res.data.status === 'DeActivated'){
          setLoading(false);
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Your user account has been deactivated, Please contact support@caledontechnologies.com'
          })
          return;
        }
      })
      .catch((error) => {
        setLoading(false); // hide the loader
        if (error.response && error.response.status === 401) {
              const respData = error.response.data
              let message = 'Email or password not correct'
              if (respData.remaining_attempts !== undefined) {
                message += ` (${respData.remaining_attempts} attempts left)`
              }

              Swal.fire({ icon: 'error', title: 'Oops...', text: message })
            }
      });
    }
    // const handleCaptchaSubmit = () => {
    //   if (userCaptchaInput.trim().toUpperCase() === captchaText.toUpperCase()) {
    //     setCaptchaError('');
    //     setCaptchaValidated(true);
    //     Swal.fire({ icon: 'success', title: 'CAPTCHA Verified' });
    //   } else {
    //     setCaptchaError('Captcha does not match. Try again.');
    //     generateCaptcha();
    //     setUserCaptchaInput('');
    //     setCaptchaValidated(false);
    //   }
    // };

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
  return (
    <div>
    {loading ? (
          <div className="loader-overlay">
              <div className="loader" style={{marginLeft:"-10px"}}>
              <PuffLoader color="#00308F" loading={true} size={200} />
              </div>
          </div>
    ) : ("")}
    <div className=' row imageStyle'>
      <div className='col-8'>
        <Slider {...settings}>
          <div>
            <img src={img} alt="Selected" width="100%" />
          </div>
          <div>
            <img src={img2} alt="Selected" width="100%" />
          </div>
        </Slider>
      </div>
    {/* <Container maxWidth="lg"> */}
        <div className='col-4 formStyle2'>
            <h2 className='text-center'><img src={logo} alt="" className='logo login_logo' /></h2>
          <form>
            <Stack spacing={3}>
                <TextField
                fullWidth
                autoComplete="Email-ID"
                type="email"
                label="Email ID"
                style={{backgroundColor:"white"}}
                value={Email}
                onChange={(e) => setEmail(e.target.value)}
                />

                <TextField
                fullWidth
                autoComplete="current-password"
                type={showPassword ? 'text' : 'password'}
                label="Password"
                style={{backgroundColor:"white"}}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                    endAdornment: (
                    <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        {showPassword ?  <FaEye />:<FaEyeSlash /> }
                        </IconButton>
                    </InputAdornment>
                    ),
                }}
                />
            </Stack>

            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
                <FormControlLabel
                control={<Checkbox checked={rememberPassword} onChange={() => setRememberPassword(!rememberPassword)} />}
                label="Remember Password"
                />

                <Link variant="subtitle2" underline="hover" onClick={() => setForgotPasswordClicked(true)}>
                Forgot Password?
                </Link>

            </Stack>

            {/* <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '1rem', 
              marginTop: '1rem',
              marginBottom: '1rem'
            }}>
              <div style={{ 
                backgroundColor: '#f0f0f0', 
                fontSize: '20px', 
                fontWeight: 'bold', 
                letterSpacing: '5px', 
                padding: '10px',
                width: 'fit-content'
              }}>
                {captchaText}
              </div>

              <TextField
                label="Enter CAPTCHA"
                value={userCaptchaInput}
                onChange={(e) => setUserCaptchaInput(e.target.value)}
                style={{ backgroundColor: "white", width: "50px" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={generateCaptcha} edge="end" title="Refresh CAPTCHA">
                        <RefreshIcon />
                      </IconButton>

                      <IconButton onClick={handleCaptchaSubmit} edge="end" title="Verify CAPTCHA">
                        <CheckCircleIcon style={{ color: captchaValidated ? 'green' : 'gray' }} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </div>

            {captchaError && <p style={{ color: 'red', marginTop: '-10px' }}>{captchaError}</p>} */}

            <Button fullWidth size="large" type="submit" variant="contained" loading={false} onClick={handleSubmit}>
                Login
            </Button>
          </form>
        </div>
    </div>
    {/* </Container> */}
    <MyModal showModal={showModal} handleClose={handleClose} />
    </div>
  );
}
